<template>
    <div class="container">
        <div class="columns is-8 is-variable">
            <div class="column is-one-quarter is-align-items-stretch">
                <div
                    @click="SET_IS_ACT_FINANCE_ACC(true)"
                    class="cta-cte card card-limit py-4 mb-5 modal-button has-background-flow"
                >
                    <CardTotalEntity
                        header="CUENTAS BANCARIAS"
                        :updated_at="lastUpdate"
                        :amount="totalFinanceAccounts"
                    />
                </div>
                <div class="card py-4">
                    <CardTotalTax
                        trending="trending_up"
                        header="Total por cobrar"
                        footer="A tus clientes"
                        :value="totalCollect"
                    />
                    <div class="horizontal-separator my-3"></div>
                    <CardTotalTax
                        trending="trending_down"
                        header="Total por pagar"
                        footer="A tus contrapartes"
                        :value="totalPay"
                    />
                </div>
            </div>
            <div class="column">
                <span
                    class="is-block has-text-weight-bold mb-0 is-size-5 has-text-left"
                >
                    Proyección de caja semanal
                </span>
                <p style="margin-bottom: 20px">Partimos de tu saldo actual y te mostramos los próximos 3 meses</p>
                <div class="is-block has-text-centered">
                <CardGraphCashFlow                      
                        @onChartRendered="onChartRendered"
                        v-if="chartObject"
                        :chartObject="chartObject"
                        :isVisible="isVisible"
                    />
                </div>
            </div>
        </div>
        <BankAccounts />
    </div>
</template>

<script>
import { parseToMoney } from "@/utils/currency";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import CardGraphCashFlow from "@/components/dashboard/consolidation/CardGraphCashFlow";
import CardTotalEntity from "@/components/dashboard/consolidation/CardTotalEntity";
import CardTotalTax from "@/components/dashboard/consolidation/CardTotalTax";
import BankAccounts from "@/components/bankAccounts/bankAccounts";
import { consoleHandlerError } from "@/utils/message";

export default {
    name: "Consolidation",
    components: {
        CardTotalTax,
        CardTotalEntity,
        CardGraphCashFlow,
        BankAccounts,
    },
    filters: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
    },
    props: {
        isVisible: Boolean
    },
    methods: {
        onChartRendered() {
            this.$emit('onChartRendered');
        },
        ...mapActions("financialEntity", ["getFinanceEntitys"]),
        ...mapMutations("financialEntity", ["SET_IS_ACT_FINANCE_ACC"]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapActions("taxDocument", ["getTotalPay", "getTotalCollect"]),
    },
    computed: {
        ...mapGetters("financialEntity", ["totalFinanceAccounts"]),
        ...mapState("taxDocument", ["totalPay", "totalCollect"]),
        ...mapState("financialEntity", ["isActFinanceAcc", "lastUpdate"]),
        ...mapState("graphCashFlow", ["chartObject"]),
    },
    created() {
        this.getFinanceEntitys();
        this.getTotalPay();
        this.getTotalCollect();
        this.getForecastFlowCash().catch((error) => {
            consoleHandlerError({ error });
        });
    },
};
</script>
